import React from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import ProductSelector from 'common/components/ProductSelector';

export default function bind() {
  const $products = $('.product.card');
  $products.each((index, element) => {
    const $element = $(element);

    const id = $element.attr('data-id');
    const name = $element.attr('data-name');
    const title = $element.attr('data-title');
    const product = $element.attr('data-product');

    ReactDOM.render(
      <ProductSelector id={id} name={name} title={title} product={product} />,
      element
    );
  });
}



// WEBPACK FOOTER //
// ./src/plugins/products.js